<template>
  <div>test</div>
</template>

<script lang="ts">
export default {
  name: 'Test',
}
</script>
